import { createSelector } from "reselect"
import { getAllLibraryCategories, getCurrentCategorySlug } from "reducers/library"
import slugify from "slugify"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

export const getLibraryCategories = createSelector(
  [getAllLibraryCategories, getBenefitConfiguration],
  (allCategories, benefitConfiguration) =>
    benefitConfiguration.featureConfig.isCarrotPregnancyEnabled
      ? allCategories
      : allCategories.filter((c) => c.fields.title !== "Pregnancy")
)

export const getCurrentCategory = createSelector(
  [getLibraryCategories, getCurrentCategorySlug],
  (categories, categorySlug) => categories.find((c) => slugify(c.fields.title) === categorySlug)
)
